import { graphql } from "@/gql";
import { ResultOf } from "@graphql-typed-document-node/core";

export const outgoingCallTallyQuery = graphql(`
  query OutgoingCallTally($from: Date!, $to: Date!) {
    outgoingCallTally(from: $from, to: $to) {
      calls
      connected
      talk_seconds
      leads
      calls_per_hour
      working_hours
      user {
        id
        name
        primary_email
      }
    }
  }
`);

export type OutgoingCallTallyItem = ResultOf<
  typeof outgoingCallTallyQuery
>["outgoingCallTally"][number];
